'use client'

import { useT } from '@/i18n/client'
import { PROGRAMS_PASSWORD_URL } from '@/utils/urls'
import { App, Button, Card, Flex, Form, Input, Typography } from 'antd'
import axios, { isAxiosError } from 'axios'
import { useRouter } from 'next/navigation'
import { useState } from 'react'

const { Title } = Typography

interface Props {
  programSlug: string
}

export const PasswordCard = ({ programSlug }: Props) => {
  const router = useRouter()
  const { message } = App.useApp()
  const { t } = useT('home')

  const [isLoading, setIsLoading] = useState(false)

  const onFinish = async (values: { password: string }) => {
    setIsLoading(true)
    try {
      const res = await axios.post(PROGRAMS_PASSWORD_URL, {
        slug: programSlug,
        password: values.password,
      })

      if (res.data?.success) {
        message.success(t('password.accessGranted'))
        router.refresh()
        return
      }
      setIsLoading(false)
    } catch (error: any) {
      if (isAxiosError(error) && error.response?.status === 401) {
        message.error(error.response.data?.error ?? t('password.invalid'))
      } else {
        message.error(error?.message ?? t('password.unexpectedError'))
      }
      setIsLoading(false)
    }
  }

  return (
    <Card style={{ maxWidth: 500 }}>
      <Flex vertical>
        <Title level={4}>{t('password.title')}</Title>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="password"
            rules={[{ required: true, message: t('password.required') }]}
          >
            <Input.Password />
          </Form.Item>
          <Button block type="primary" htmlType="submit" loading={isLoading}>
            {t('password.submit')}
          </Button>
        </Form>
      </Flex>
    </Card>
  )
}
